import { useTranslation } from 'react-i18next';
import { cn } from '../../../utils/cn';
import type { TransferStatus } from '../../../types/nursery';

// Labels: status.<key> in the TransferStatusBadge locale file.
const STYLES: Record<TransferStatus, string> = {
  planned:    'bg-neutral-100 text-neutral-700',
  in_transit: 'bg-blue-100 text-blue-700',
  received:   'bg-green-100 text-green-700',
  cancelled:  'bg-red-100 text-red-700',
};

export function TransferStatusBadge({ status }: { status: TransferStatus }) {
  const { t } = useTranslation('nursery', { keyPrefix: 'TransferStatusBadge' });
  const cls = STYLES[status];
  return <span className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold whitespace-nowrap', cls)}>{t(`status.${status}`)}</span>;
}

export default TransferStatusBadge;
